import {
  NETWORK_FEED_TYPE,
  GROUP_FEED_TYPE,
  MY_GROUPS_FEED_TYPE,
} from '../constants/FeedType';

export const getItemsDedicatedUrl = ({ item, liveFeedType, currentUrl }) => {
  if (liveFeedType === NETWORK_FEED_TYPE) {
    switch (item.type) {
      case 'communications_post_communication':
        return `${currentUrl.origin}${Routes.new_path(item.id)}`;

      case 'event':
        return `${currentUrl.origin}${Routes.event_preview_path(item.id)}`;

      case 'network_events_event':
        return `${currentUrl.origin}${Routes.networks_event_path(item.id)}`;

      case 'business_opportunities_request':
        return `${currentUrl.origin}${Routes.opportunity_path(item.id)}`;

      case 'surveys_form':
        return `${currentUrl.origin}${Routes.surveys_form_path(item.id)}`;

      case 'ventures_venture':
        return `${currentUrl.origin}${Routes.venture_path(item.id)}`;

      case 'user':
        return `${currentUrl.origin}${Routes.user_path(item.id)}`;

      case 'posts_feed_post':
        return `${currentUrl.origin}${Routes.feed_post_path(item.id)}`;

      case 'current':
        return `${currentUrl.origin}${Routes.check_in_path(item.id)}`;

      case 'trip':
        return `${currentUrl.origin}${Routes.trip_path(item.id)}`;

      case 'tweet':
      default:
        return null;
    }
  }

  if (
    liveFeedType === GROUP_FEED_TYPE ||
    liveFeedType === MY_GROUPS_FEED_TYPE
  ) {
    switch (item.type) {
      case 'communications_post_communication':
        return `${currentUrl.origin}${Routes.new_path(item.id)}`;

      case 'posts_topic_post':
        return `${currentUrl.origin}${Routes.topic_topic_feed_posts_path(
          item.topic_id,
          item.id,
        )}`;

      case 'tweet':
      default:
        return null;
    }
  }

  return null;
};
